import type {InvoiceItem} from '../../types';

import {Button, Card} from '@ds/components';
import {useNavigate} from 'react-router-dom';
import {numberFormat} from 'utils/Helper';

import InvoiceDataRow from '../common/InvoiceDataRow/InvoiceDataRow';

type InvoiceCardProps = {
  invoice: InvoiceItem;
};

const formatAmount = (amount?: number) => `${numberFormat(Math.abs(amount ?? 0))} تومان`;

const InvoiceCard: React.FC<InvoiceCardProps> = ({invoice}) => {
  const navigate = useNavigate();

  if (!invoice.is_final) {
    return (
      <Card className="w-full" size="small" title={invoice.title}>
        <InvoiceDataRow
          title="پرداختی علی الحساب ماه"
          value={formatAmount(invoice.payment_amount)}
          highlighted
        />
        <InvoiceDataRow title="تعداد سفارش" value={numberFormat(invoice.order_count ?? 0)} />
        <InvoiceDataRow title="مبلغ فروش ماه" value={formatAmount(invoice.total_sale)} />
      </Card>
    );
  }

  const adjustmentTone =
    invoice.order_adjustment_amount === 0
      ? 'default'
      : invoice.order_adjustment_amount && invoice.order_adjustment_amount > 0
        ? 'success'
        : 'error';

  return (
    <Card
      className="w-full"
      extra={
        <Button size="sm" onClick={() => navigate(`/invoice/${invoice.id}`)} variant="outline">
          جزئیات
        </Button>
      }
      size="small"
      title={invoice.title}
    >
      <InvoiceDataRow title="تعداد سفارش خالص" value={numberFormat(invoice.order_count ?? 0)} />
      <InvoiceDataRow title="مبلغ فروش ناخالص" value={formatAmount(invoice.gross_sales_amount)} />
      <InvoiceDataRow
        title="مبلغ اصلاح سفارشات سیستمی"
        value={formatAmount(invoice.order_adjustment_amount)}
        tone={adjustmentTone}
      />
      <InvoiceDataRow
        title="مبلغ سفارشات کنسل شده"
        value={formatAmount(invoice.order_cancellation_amount)}
        tone="error"
      />
      <InvoiceDataRow title="مبلغ فروش خالص" value={formatAmount(invoice.total_sale)} />
      <InvoiceDataRow
        title="کسر کمیسیون اسنپ"
        value={formatAmount(invoice.snapp_commission_amount)}
        tone="error"
      />
      <InvoiceDataRow
        title="کسر مالیات کمیسیون اسنپ"
        value={formatAmount(invoice.snapp_vat_amount)}
        tone="error"
      />
      <InvoiceDataRow
        title="کسر بابت کوپن هزینه ارسال"
        value={formatAmount(invoice.vendor_delivery_coupon_share)}
        tone="error"
      />
      <InvoiceDataRow
        title="کسر بابت کوپن تخفیفی"
        value={formatAmount(invoice.coupon_discount)}
        tone="error"
      />
      <InvoiceDataRow
        title="مجموع سایر کسورات"
        value={formatAmount(invoice.total_deductions)}
        tone="error"
      />
      <InvoiceDataRow
        title="پرداختی ارسال پیک فروشگاه"
        value={formatAmount(invoice.delivery_fee)}
        tone="success"
      />
      <InvoiceDataRow
        title="پرداختی ووچر ارسال رایگان پیک فروشگاه"
        value={formatAmount(invoice.vendor_delivery_voucher_share)}
        tone="success"
      />
      <InvoiceDataRow
        title="مجموع سایر اضافات"
        value={formatAmount(invoice.total_additions)}
        tone="success"
      />
      <InvoiceDataRow
        title="آخرین پرداختی ماه"
        value={formatAmount(invoice.payment_amount)}
        tone="success"
        highlighted
      />
      <InvoiceDataRow
        title="مجموع واریزی‌های ماه"
        value={formatAmount(invoice.total_paid)}
        tone="success"
        highlighted
      />
      <Button
        fullWidth
        variant="outline"
        size="md"
        onClick={() => navigate(`/invoice/${invoice.id}`)}
      >
        جزئیات
      </Button>
    </Card>
  );
};

export default InvoiceCard;
